import { Modal, Box, Typography, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material"; // Import the close icon
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { offBoardUser } from "../../services/common";
import toast from "react-hot-toast";
import { LoadingButton } from "@mui/lab";
import { logout } from "../../services/user/UserServices";
const CancelSubscription = ({ open, handleClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const handleLogout = async () => {
    const result = await logout();
    if (result?.success) {
      localStorage.clear();
      window.location = "/login";
      handleClose();
    }
  };
  const handleSubmit = async () => {
    setIsLoading(true);
    let offboarduser = await offBoardUser();
    if (offboarduser.success == true) {
      setIsLoading(false);
      handleClose();
      await handleLogout();

    } else {
      toast.error(offboarduser?.message);
    }

  };

  return (
    <Modal open={open} onClose={handleClose} >
      <Box className="modal">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {t("cancel-subscription-heading")}
          </Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          <p className="modal-content">{t("cancel-subscription-contents")}</p>
        </Typography>
        <Box className="modal-box">
          <LoadingButton
            variant="contained"
            className="modal-btn"
            onClick={handleSubmit}
            //loading={isLoading}
            disabled={isLoading}
          >
            <span> {t("cancel-subscription-btn-content")}</span>
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default CancelSubscription;
